// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_K827D,.container_K827D *{box-sizing:border-box;-webkit-font-smoothing:antialiased;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.container_K827D{border-radius:0;background:#fff;border-bottom:1px solid rgba(0,0,0,.15)}.header_2IHr2{display:flex}.closeButton_11hgN{display:flex;align-items:center;justify-content:center;width:60px;height:60px;cursor:pointer}.closeButton_11hgN .closeIcon_2i2Ws{width:14px;height:14px;color:#272525}", ""]);
// Exports
exports.locals = {
	"container": "container_K827D",
	"header": "header_2IHr2",
	"closeButton": "closeButton_11hgN",
	"closeIcon": "closeIcon_2i2Ws"
};
module.exports = exports;
